import React from 'react'
import classNames from 'classnames'

export default function PageMainContent({
    children,
}) {

    const Classes = classNames({
        "w-screen md:w-full overflow-x-hidden flex-1 pt-5 lg:pt-10 pb-120 md:pb-100 overflow-scroll": true,
    })

    return (
        <div className={Classes}>
            {children}
        </div>
    )
}
